import { FC, ReactNode } from 'react';

import { DebouncedSearchInput } from '../../components/shared/DebouncedSearchInput';

interface Props {
    readonly query: string;
    readonly loading: boolean;
    readonly onSearch: (query: string) => void;
    readonly actions?: ReactNode;
}

export const SellerCatalogSearch: FC<Props> = ({
    query,
    loading,
    onSearch,
    actions,
}) => (
    <div
        className="container px-4 pb-2 sm:px-6 lg:px-8"
        data-testid="seller-catalog-search"
    >
        <div className="flex flex-col gap-2 rounded-2xl border border-border/70 bg-background p-3 shadow-sm sm:flex-row">
            <DebouncedSearchInput
                query={query}
                loading={loading}
                onSearch={onSearch}
                placeholder="Пошук у пропозиціях продавця"
                inputTestId="seller-catalog-search-input"
                submitLabel="Пошук"
                className="min-w-0 flex-1"
                inputClassName="h-11 text-base sm:text-sm"
            />
            {actions}
        </div>
    </div>
);
